import React from 'react';
import { string } from 'prop-types';

const Weight = ({ className = '' }) => (
  <svg className={className} width="1.8rem" height="1.8rem" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M11.639 6C11.8982 5.55874 12.0466 5.04643 12.0466 4.5C12.0466 2.84315 10.6826 1.5 9 1.5C7.31743 1.5 5.95344 2.84315 5.95344 4.5C5.95344 5.04643 6.1018 5.55874 6.36102 6H3.56745C3.18842 6 2.86707 6.27445 2.81347 6.64393L1.5078 15.6439C1.44225 16.0958 1.79829 16.5 2.26178 16.5H15.7382C16.2017 16.5 16.5577 16.0958 16.4922 15.6439L15.1865 6.64393C15.1329 6.27445 14.8116 6 14.4325 6H11.639ZM10.25 4.48889C10.25 5.17925 9.69036 5.73889 9 5.73889C8.30965 5.73889 7.75 5.17925 7.75 4.48889C7.75 3.79854 8.30965 3.23889 9 3.23889C9.69036 3.23889 10.25 3.79854 10.25 4.48889Z" fill="#696F88" />
  </svg>
);

Weight.propTypes = { className: string };

export default Weight;
